import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";

interface ArtworkHeaderProps {
  title: string;
  registrationNumber: string;
  t: (key: string) => string;
}

export function ArtworkHeader({
  title,
  registrationNumber,
  t,
}: ArtworkHeaderProps) {
  return (
    <div className="flex items-center justify-between subpixel-antialiased">
      <div className="flex items-center gap-3 mb-1 w-full">
        <p className="font-semibold text-4xl w-full">{title}</p>
        <span className="border-r border-1 border-gray-400 h-9"></span>
        <HoverCard>
          <HoverCardTrigger className="font-semibold text-lg w-full text-black cursor-pointer">
            {registrationNumber}
          </HoverCardTrigger>
          <HoverCardContent
            className="font-semibold text-xs p-2 border-none shadow"
            side="top"
          >
            {t("singleArtworkHoverCardNumber")}
          </HoverCardContent>
        </HoverCard>
      </div>
    </div>
  );
}
